import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { ForbrukService } from 'src/app/services/forbruk/forbruk.service';
import { Anlegg, DagResponse } from 'src/app/services/forbruk/forbruk.types';
import { sumNum } from 'src/app/utils/array-utils';
import {
  hasIfjor,
  comparePeriod,
  toRoundNumberHour,
  getIfjorLowest,
  getIfjorHighest,
  getIfjorSnitt,
  getIFjorPluss,
  getIFjor,
  thisPeriod,
  capFirst
} from '../forbrukstall-utils';
import { hasChanged } from 'src/app/utils/change-utils';
@Component({
  selector: 'app-forbruk-hour',
  templateUrl: './hour.component.html',
  styleUrls: ['./hour.component.scss']
})
export class ForbrukHourComponent {
  @Input() valgtAnlegg: Anlegg;
  @Input() selectedDate: Date;

  isPlusskunde: boolean;
  selectedPeriod: string;
  avgForbruk: number;
  estimateForbruk: number;
  highestForbruk: number;
  lowestForbruk: number;
  lastYear: number;
  ifjorResponse: any;
  produksjon: number;
  hasCompleteMonth: boolean;

  hasIfjor = hasIfjor;
  comparePeriod = comparePeriod;
  toRoundNumber = toRoundNumberHour;
  getIfjorLowest = getIfjorLowest;
  getIfjorHighest = getIfjorHighest;
  getIfjorSnitt = getIfjorSnitt;
  getIFjorPluss = getIFjorPluss;
  getIFjor = getIFjor;
  thisPeriod = thisPeriod;
  capFirst = capFirst;

  constructor(private _forbrukService: ForbrukService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (hasChanged([changes.valgtAnlegg])) {
      this.calcHourValues();
    }
  }

  calcHourValues() {
    this.isPlusskunde = this.valgtAnlegg.plusskunde;
    this.selectedPeriod = this.selectedDate.toLocaleDateString('nb-NO', {
      month: 'long',
      day: 'numeric'
    });
    const noOfDays = new Date(
      this.selectedDate?.getFullYear(),
      this.selectedDate.getMonth() + 1,
      0
    ).getDate();
    const verdier = this.valgtAnlegg.verdiList.map((x) => x.verdi);
    this.avgForbruk = sumNum(verdier) / verdier.length;
    this.highestForbruk = Math.max(...verdier);
    this.lowestForbruk = Math.min(...verdier);
    this.estimateForbruk = sumNum(verdier);

    const sisteVerdi =
      this.valgtAnlegg.verdiList[this.valgtAnlegg.verdiList.length - 1].dato;
    this.hasCompleteMonth = noOfDays === new Date(sisteVerdi).getDate();

    this.lastYear = this.selectedDate.getFullYear() - 1;
    this.ifjorResponse = this._forbrukService.getForbrukTimeDag(
      new Date(
        this.lastYear,
        this.selectedDate.getMonth(),
        this.selectedDate.getDate(),
        12,
        0,
        0
      ),
      false
    );
    if (this.isPlusskunde) {
      this.produksjon =
        sumNum(this.valgtAnlegg.verdiList?.map((x) => x.plussverdi)) || 0;
    }
  }
}
